import { PropsWithChildren } from 'react'
import { styled } from '@mui/material'
import Appbar from './appbar'
import MediaDetailsDrawer from './drawers/MediaDetails'
import Alerts from './Alerts'
import useBucketMediaByShareId from '../hooks/useBucketMediaByShareId'
import Loading from '../../../components/PageLoading'
import ShareAlbumsDrawer from './drawers/ShareAlbumsDrawer'
import useBucketShareAlbums from '../hooks/useBucketShareAlbums'
import useBucketShareById from '../hooks/useBucketShareById'
import { BucketShareType } from '../../../graphql/generated'

const Main = styled('main')({
  display: 'flex',
  flex: 1,
  overflowX: 'hidden',
  flexDirection: 'column',
  position: 'relative'
})

const Wrapper = styled('div')(() => ({
  display: 'flex',
  flex: 1
}))

/**
 * Renders Layout For Slideshow
 * @param props Component properties with child components
 */

export function FullscreenLayout({ children }: PropsWithChildren<{}>) {
  const { loading } = useBucketMediaByShareId()

  if (loading) {
    return <Loading />
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Wrapper>
        <Main id="main">{children}</Main>
      </Wrapper>
      <Alerts />
      <MediaDetailsDrawer />
    </div>
  )
}

/**
 * Renders Layout For Gallery
 * @param props Component properties with child components
 */

export default function GalleryLayout({ children }: PropsWithChildren<{}>) {
  const { bucketShare } = useBucketShareById()
  const { albums } = useBucketShareAlbums(bucketShare)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Appbar displayDrawerToggle={false} />
      <Wrapper>
        {bucketShare?.shareType !== BucketShareType.Media && <ShareAlbumsDrawer albums={albums} />}
        <Main id="main">{children}</Main>
      </Wrapper>
      <Alerts />
      <MediaDetailsDrawer />
    </div>
  )
}
